import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import { unauthorizedInterceptor } from './app/interceptors/unauthorized.interceptor';
import { ErrorHandler, LOCALE_ID } from '@angular/core';
import * as SentryAngular from '@sentry/angular';
import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import localePtBrExtra from '@angular/common/locales/extra/pt';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

registerLocaleData(localePtBr, 'pt-BR', localePtBrExtra);

// Monitoramento de erros (Sentry). Só envia quando há DSN configurado no ambiente de produção.
const sentryDsn = (environment as { sentryDsn?: string }).sentryDsn ?? '';
SentryAngular.init({
  dsn: sentryDsn || undefined,
  enabled: !!sentryDsn,
  environment: environment.production ? 'production' : 'development',
  sendDefaultPii: false,
  tracesSampleRate: 0,
});

bootstrapApplication(AppComponent, {
  providers: [
    { provide: ErrorHandler, useValue: SentryAngular.createErrorHandler() },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      scrollAssist: false,
      scrollPadding: false
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([unauthorizedInterceptor])),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
});
